module.exports = __webpack_public_path__ + "img/invoice-de-male-wm-banner-by.40b42f4b.png";